<template>
    <div>
        <!-- 操作-->

        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding: 20px 0px;text-align: left">
            <el-form :inline="true" :model="topForm" ref="topForm">
                <el-form-item>
                    <el-button type="primary" class="" @click="add()"><i class="fa fa-star"></i>&nbsp新增
                    </el-button>
                </el-form-item>

                <el-form-item prop="name" style="margin-left: 8%">
                    <el-input v-model="topForm.name" placeholder="提货码名称" ></el-input>
                </el-form-item>

                <el-form-item style="margin-left: 2%">
                    <el-button type="primary" class="" @click="getData()" icon="search":loading="loading">查询</el-button>
                </el-form-item>
                <!--<el-form-item style="position:absolute;left: 90%">
                  <el-button type="primary"  @click="add()">新增</el-button>
                </el-form-item>-->
                <!--<el-form-item>
                  <el-button type="primary" @click="resetForm('topForm')">重置</el-button>
                </el-form-item>-->

            </el-form>
        </el-col>

        <!-- 弹窗新增标签-->
        <!--<el-button type="text" >打开嵌套表单的 Dialog</el-button>-->
        <el-dialog title="添加库存" :visible.sync="dialogFormVisible" :modal-append-to-body="false" @close="dialodclose('exlForm')">
            <el-form  :model="exlForm" :rules="exlrules" ref="exlForm"  >

                <el-form-item label="库存" prop="count" v-if="isable==false">
                    <el-input  v-model="exlForm.count" placeholder="请输入库存数量"></el-input>
                </el-form-item>
                <!-- with-credentials -->
                <el-form-item prop="fileList" label="导入库存" v-if="isable==true">
                    <el-upload
                            class="upload-demo"
                            ref="upload"

                            :action="uploadurl"
                            :data="upload_data"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-success="handleSuccess"
                            :before-upload="handletype"
                            :file-list="exlForm.fileList"
                    >
                    <span v-bind:class="{isable:isorno}">
                            <el-button size="small" type="success">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">大小不超过5GB</div>
                        </span>
                    </el-upload>
                </el-form-item>

                <el-form-item label="表格名称" prop="exlName" v-show="false">
                    <el-input v-model="exlForm.exlName" placeholder="exlName" style="width: 60%;" ></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" >取 消</el-button>
                <el-button type="primary" @click="submitForm('exlForm')">保存</el-button>
                <!--<el-button type="primary" @click="dialogFormVisible = false">保存</el-button>-->
            </div>
        </el-dialog>

        <!-- 表格分页-->
        <div class="block">
            <el-table element-loading-text="拼命加载中" ref="table" :data="tableData" border style="width: 100%">
                <el-table-column prop="excodeName" label="提货码名称" > </el-table-column>
                <el-table-column prop="count" label="总数量">  </el-table-column>
                <el-table-column prop="remain" label="库存数量">  </el-table-column>
                <el-table-column prop="excodeType" label="提货码类型">
                    <template scope="scope">
                        <div v-if="scope.row.excodeType==1">预生成</div>
                        <div v-if="scope.row.excodeType==0">系统生成</div>
                    </template>
                </el-table-column>
                <el-table-column prop="expTime" label="过期时间" :formatter="formatterstart">  </el-table-column>
                <el-table-column label="操作" width="255px">
                    <template scope="scope" >
                        <!--<el-button  size="small"  @click="advertiseInfo(scope.row)" >查看</el-button>-->
                        <el-button  size="small"  @click="advertiseEdit(scope.row)" >编辑</el-button>
                        <el-button  size="small" v-if="scope.row.status == '1'" type="danger" @click="unassignAct(scope.row)" >停用</el-button>
                        <el-button  size="small"  type="primary" v-if="scope.row.status == '0'"  @click="assignAct(scope.row)" >启用</el-button>
                        <el-button  size="small" type="primary" @click="addKuCun(scope.row)" >添加库存</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="block">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-chahange="handleSizeChange"
                    :current-page="currentpage"
                    :page-count="pagesCount"
                    :page-sizes="pagesizes"
                    :page-size="pagesize"
                    :total="pagesCount"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>


        </div>

    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    export  default{
        data(){
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                ecxcode: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                /*弹窗选择*/
                dialogFormVisible: false,
                isable:false,
                //参数设置
                url: this.requetCodeHost+"/exManager/findExcodeInfos", // 分页查询请求路径
                //uploadurl:this.requetHost+"/exManager/UplodExlFile",
                uploadurl:"http://47.99.129.28:80/activity/exManager/UplodExlFile",
                upload_data:{
                    type:this.apkUploadWay,
                    folder:"app"
                },
                name:'',
                options: [
                ],
                loading:false,
                /*弹窗内容选择*/
                topForm:{
                    name:''
                },
                exlForm:{
                    count:'',
                    exlName:'',
                    id:'',
                    fileList:[]
                },
                exlrules:{

                },
                isorno:false,
                isorginit:'0',
                issecondorginit:'0',
                orglevel:'',
                isSecondable:true,
                isLastable:true,
            }

        },
        created(){
            this.getData();
        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.ecxcode=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.ecxcode=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getData();
            },
            getData(){
                //数据请求
                this.loading = true
                var params = {active:this.ecxcode,len:this.pagesize,excodeName:this.topForm.name,
                    Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'/*localStorage.getItem('Token')*/};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {

                            if(response.body.code=='500') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }else if (response.body.code=='501') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }else{
                                this.pagesCount = response.body.total
                                this.tableData = response.body.data
                                this.loading = false;
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
                this.fileSpan();
            },
            assignAct(row) {
                var params={id:row.id,Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'}
                this.$store.dispatch('excodeClient',params).then((res) => {
                    if(res.code==="200") {
                        //this.ruleForm.asignState='0';
                        this.$message({showClose: true, message: '提货码启用成功', type: 'success'});
                    }else if(res.code === "501"){
                        this.$message({showClose: true, message: res.msg, type: 'success'});
                    }else{
                        this.$message({showClose: true,message: '提货码启用成功',type: 'error'});
                    }
                    this.getData();

                });
            },
            unassignAct(row) {
                var params={id:row.id,Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'}
                this.$store.dispatch('excodeClient',params).then((res) => {
                    if(res.code=="200") {
                        //this.ruleForm.asignState='0';
                        this.$message({showClose: true, message: '提货码停用成功', type: 'success'});
                    }else if(res.code === "501"){
                        this.$message({showClose: true, message: res.msg, type: 'success'});
                    }else{
                        this.$message({showClose: true,message: '提货码停用失败',type: 'error'});
                    }
                    this.getData();

                });
            },
            formatter(row, column) {
                var d = new Date(row.updateTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            add(){
                this.savecookie("button", "excodeAdd");
                this.$router.push( {path:"excodeAdd"})
            },
            advertiseEdit(row){
                this.savecookie("button", "excodeModify");
                this.$router.push( {path:"excodeModify",query:{id:row.id,actId:row.actId}});
            },
            advertiseInfo(row){
                this.$router.push( {name:"activityInfo",params:{actId:row.actId}});
            },
            formatterstart(row, column) {
                var d = new Date(row.expTime);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            addKuCun(row){
                if (row.excodeType === "1"){
                    this.isable = true;
                }else {
                    this.isable = false;
                }
                this.exlForm.id = row.id;
                this.dialogFormVisible=true;
            },
            handletype(file) {
                var n = file.name.split(".");
                var len =n.length;
                var type = n[len-1];
                if(type!=="xls" && type !== "xlsx") {
                    this.$message({showClose: true, message: '只能选择.xls', type: 'error'});
                    this.clear("upload");
                    return false;
                }
                if(this.exlForm.fileList.length>=0){
                    this.isorno=true;
                };
            },
            handleRemove(file, fileList) {
                this.isorno=false;
                this.exlForm.fileList = fileList;
            },
            handlePreview(file) {
            },
            handleSuccess(response, file, fileList){
                this.exlForm.fileList = fileList;
                this.exlForm.exlName = response.path;
            },

            submitUpload(fileList) {
                this.$refs.upload.submit();
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var params={id:this.exlForm.id,count:this.exlForm.count,fileName:this.exlForm.exlName,Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'};
                        this.$store.dispatch('addExcodeStock',params).then((data)=>{
                            if(data.res=="success") {
                                this.$message({showClose: true, message: '添加成功', type: 'success'});
                                this.getData();
                            }else if(data.code === "501"){
                                this.$message({showClose: true,message: data.msg ,type: 'error'});
                            }else{
                                this.$message({showClose: true,message: '添加失败',type: 'error'});
                            }
                            this.dialogFormVisible=false;
                        })


                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            /**--------------------------------------end--------------------------------------------------------**/
            fileSpan(){
                this.isorno=false;
            },
            dialodclose(formName) {
                this.$refs[formName].resetFields();
                //this.getData();
            },
            /**--------------------------------------end--------------------------------------------------------**/

        }

    }

</script>



// WEBPACK FOOTER //
// ExcodeManager.vue?7e66d946